import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import Dialog from 'material-ui/Dialog';
import { renderCheckBox, renderTextField, renderTextArea } from '../../../../../../components/reduxFields';
import { getConsequencesListDetails, saveConsequences } from './actions/consequencesActions';
import { CancelButton, SubmitButtonModal, SubmitButtonModalDisabled } from '../../../../../../components/buttons';
import SmallLoader from '../../../../../../img/small-loader.gif';
import { checkFieldExistence, clearFieldErrorArray } from '../../../../../AppConfig/actions';
import { MODULE } from './constants/ApiConstants';
import { displayCustomError } from '../../../../../../actions/utilAction';

const validate = (values) => {
  const errors = {};
  if (!values.consequenceName) {
    errors.consequenceName = 'Please enter consequence name';
  }
  return errors;
};

class ConsequencesModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
    };
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleNewRequest = this.handleNewRequest.bind(this);
  }

  componentWillMount() {
    if (this.props.consequencesId) {
      this.props.getConsequencesListDetails(this.props.consequencesId);
    }
  }

  handleOpen = () => {
    this.setState({ open: true });
  };
  handleClose = () => {
    if (this.state.open) {
      this.setState({ open: false });
      this.props.closeDialog();
    }
  };
  componentWillReceiveProps(nextProps) {
    let self = this;
    document.onkeydown = function (evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };
  }

  onSubmitHandler(formProps) {
    if ((this.props.fieldError && this.props.fieldError.length) || (this.props.fieldErrorLoading)) { // Avoid Submit if field error checking
      return null;
    }

    let postData = {
      "id": this.props.consequencesId || 0,
      "patientId": this.props.patientId,
      "consequenceName": formProps.consequenceName,
      "description": formProps.description || '',
      "isActive": formProps.isActive || false,
      "excludeFromABCDataCollection" : formProps.excludeFromABCDataCollection || false,
      "totalRecords": 0,
      "actionName": "DATA COLLECTION SETUP"
    }

    // console.log(postData);
    this.props.saveConsequences(postData, this.props.patientId);
    this.props.closeDialog();
  }

  checkFieldDataExistence = (input, value, labelName) => {
    if (value.length > 0) {
      let postData = {
        'labelName': labelName,
        'tableName': `${MODULE}_${input.target.name}`.toUpperCase(),
        'value': value,
        'colmnName': input.target.name.toUpperCase(),
        'id': this.props.consequencesId || 0,
        'patientId': this.props.patientId ? parseInt(this.props.patientId) : 0,
      };
      this.props.checkFieldExistence(postData);
    }
  };

  handleNewRequest = (input, selectedRecord) => {
    input.onChange(selectedRecord.value);
  }


  renderLoading() {
    return (
      <div>
        {this.props.loading ?
          <div className="full_loader top0">
            <div className="small-loader">
              <img src={SmallLoader} alt="" />
            </div>
          </div>
          : null}
      </div>
    );
  }

  render() {
    const { handleSubmit } = this.props;
    let submitButton = this.props.loading ?
      <SubmitButtonModalDisabled label="Loading" /> :
      <SubmitButtonModal label="Save" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))} />;
    const actions = [
      <CancelButton className="mr-15" onTouchTap={this.handleClose} />,
      submitButton,
    ];
    return (
      <div>
        <Dialog
          className="custom_modal"
          title={this.props.consequencesId ? 'Edit Consequences' : 'Add Consequences'}
          modal={false}
          open={this.state.open}
          actions={actions}
          autoScrollBodyContent={true}
        >
          {this.renderLoading()}
          <div className="row">
            <div className="col-sm-12">
              <form className="readmin-form custom_form">
                <div className="row">
                  <div className='col-sm-12 require'>
                    <Field
                      name="consequenceName"
                      label="Consequences Name"
                      type="text"
                      onBlur={(input, value) => this.checkFieldDataExistence(input, value, 'Consequences name')}
                      customError={displayCustomError('CONSEQUENCENAME', this.props.fieldError)}        
                      maxLength="250"
                      component={renderTextField}
                      autoFocus="true"
                    />
                  </div>
                  <div className='col-sm-12 mt-10'>
                    <Field
                      name="description"
                      type="text"
                      maxLength="1000"
                      label="Definition"
                      // normalize ={isValidNameWithSpace}
                      component={renderTextArea} />
                  </div>
                  <div className="col-sm-6">
                    <Field className="mt20 mb0 custm_check"
                      name="excludeFromABCDataCollection"
                      label="Exclude From ABC Data Collection"
                      component={renderCheckBox}
                    />
                  </div>
                  <div className="col-sm-6">
                    <Field className="mt20 mb0 custm_check"
                      name="isActive"
                      label="Is Active"
                      component={renderCheckBox}
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </Dialog >
      </div >
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let initialValueData = {
    isActive: true,
  };
  if (ownProps.consequencesId && state.patient_consequences.consequencesDetail) {
    initialValueData = state.patient_consequences.consequencesDetail.data;
  }
  return {
    initialValues: initialValueData,
    fieldError: state.appConfig.fieldError,
    fieldErrorLoading: state.appConfig.fieldErrorLoading,
    consequencesDetail: state.patient_consequences.consequencesDetail,
    loading: state.patient_consequences.loading,
  };
};

ConsequencesModal = reduxForm({
  form: 'ConsequencesModalForm', // a unique identifier for this form
  validate,
  enableReinitialize: true,
})(ConsequencesModal);

export default connect(mapStateToProps, { saveConsequences, getConsequencesListDetails, checkFieldExistence, clearFieldErrorArray })(ConsequencesModal);



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/BehaviorReductiom/Consequences/consequences_Modal.js